// +----------------------------------------------------------------------
// | 我的资料
// | 2026-09-29：编辑表单拆到子页 /profile/edit（点「个人信息」行进去），
// | 这页只留展示 + 各入口，主体清爽
// +----------------------------------------------------------------------
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getProfile } from '../../api/user';
import { toast } from '../../components/Toast';
import { formatFull } from '../../lib/format';
import VipEntry from '../../components/VipEntry';
import EntrySwitches from '../../components/EntrySwitches';
import '../../components/EntrySwitches/EntrySwitches.less';
import './Profile.less';

export default function Profile() {
  const [loading, setLoading] = useState(true);
  const [account, setAccount] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const data = await getProfile();
        if (!mounted) return;
        setAccount(data.user || {});
      } catch (e) {
        if (mounted) toast(e.message || '资料没拉到', 'error');
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  if (loading) {
    return <div className="page center muted">正在加载…</div>;
  }

  const nickname = (account && (account.nickname || account.username)) || '';
  const initial = nickname ? nickname.slice(0, 1).toUpperCase() : '';

  return (
    <div className="page profile">
      <h1 className="profile-title">我的资料</h1>

      {/* 头像卡即「个人信息」入口：整卡可点，进编辑子页（表单在 /profile/edit） */}
      <Link to="/profile/edit" className="card profile-head" aria-label="编辑个人信息">
        <div className="profile-avatar">{initial}</div>
        <div className="profile-head-info">
          <strong>{nickname || '还没起昵称'}</strong>
          <span className="muted">@{account ? account.username : ''}</span>
          {account && account.created_at && (
            <span className="muted">加入于 {formatFull(account.created_at)}</span>
          )}
        </div>
        <span className="profile-head-arrow">›</span>
      </Link>

      {/* 会员只留一行：是不是会员 / 到期时间，点进去才是开通续费（/vip） */}
      <VipEntry />

      {/* 领体验码 / 下载 App */}
      <EntrySwitches variant="plain" />

      <div className="profile-docs">
        <a href="/agreement.html" target="_blank" rel="noreferrer">用户服务协议</a>
        <span>·</span>
        <a href="/privacy.html" target="_blank" rel="noreferrer">隐私政策</a>
      </div>
    </div>
  );
}
